export default "__VITE_ASSET__o10iuZ____"